export const makePublicUrl = (filePath: string): string =>
  `${process.env.PUBLIC_URL}/${filePath}`
